import { formatDate, formatTime } from '@/utils/formatters'

function formatSignedAmount(amount) {
  const value = parseFloat(amount) || 0
  const abs = Math.abs(value).toFixed(2)
  return value < 0 ? `-$${abs}` : `$${abs}`
}

function resolvePaymentStatus(transaction) {
  const type = String(transaction.type ?? '')
  if (type === '1118') return 'Pending'
  if (type === '1115') return 'Complete'

  // Mapped list items store type_description as description
  return transaction.type_description || transaction.description || ''
}

export function mapCardTransactionListItem(transaction) {
  const amount = parseFloat(transaction.amount) || 0

  return {
    id: transaction.id || Math.random(),
    occurredAt: transaction.occurred_at || '',
    date: formatDate(transaction.occurred_at),
    description: transaction.type_description || '',
    card_acceptor_location: transaction.card_acceptor_location || '',
    moneyIn: amount > 0 ? Math.abs(amount) : null,
    moneyOut: amount < 0 ? Math.abs(amount) : null,
    amount,
    balance: transaction.running_balance_amount || 0,
    cardType: transaction.card_type || '',
    paymentStatus: resolvePaymentStatus(transaction),
    reference: transaction.reference || transaction.id || '',
    type: transaction.type || ''
  }
}

export function toTransactionDetail(transaction, { showCardType = true } = {}) {
  const amount = transaction.amount ?? (
    transaction.moneyOut != null ? -transaction.moneyOut : transaction.moneyIn
  )
  const occurredAt = transaction.occurredAt || transaction.occurred_at
  const cardType = transaction.cardType || transaction.card_type || ''

  return {
    merchant: transaction.card_acceptor_location || transaction.description || 'N/A',
    amount: formatSignedAmount(amount),
    date: transaction.date || formatDate(occurredAt),
    time: formatTime(occurredAt),
    cardType: showCardType && cardType ? cardType.toUpperCase() : '',
    paymentStatus: resolvePaymentStatus(transaction),
    reference: transaction.reference || transaction.id || 'N/A'
  }
}
